import storageManager from './managers/storage-manager'
import styleManager from './managers/style-manager'
import assetManager from './managers/asset-manager'
import blockManager from './managers/block-manager'
import deviceManager from './managers/device-manager'
import layerManager from './managers/layer-manager'
import traitManager from './managers/trait-manager'
import selectorManager from './managers/selector-manager'
import pluginsOpts from './plugins-opts'
import plugins from './plugins'
import canvas from './canvas'
import videoEmbedPlugin from '../components/video'

export default function options(headless = false) {
  const headfulOptions = {
    container: '#gjs',
    fromElement: true,
    showOffsets: true,
    height: '100%',

    // Config files
    ...styleManager,
    ...layerManager,
    ...traitManager,
    ...selectorManager,
    ...blockManager,
    ...deviceManager,
    ...assetManager,
    ...pluginsOpts(),
    ...plugins,
    ...canvas(),
  }

  return {
    ...storageManager(),
    ...(headless ? { headless: true, plugins: [videoEmbedPlugin] } : headfulOptions),
    telemetry: false,
    protectedCss: '',
    allowScripts: true,
  }
}
